import React from 'react';
import {WhiteSpace} from 'antd-mobile';

const isMobile = /Android|iPhone|iPod|iPad/i.test(navigator.userAgent);

function getDisplayName(component){
    return component.displayName || component.name || 'Component';
}
function WrapComponent(Element){
    
    let Component = (props)=>{

        //隐藏字段
        let {getFieldError} = props.form;
        let error = getFieldError(props.api_name);
        // 增加label, help_text提示信息
        let requireText = ( props.is_required ? <span className="input-required">*</span> : null);
        let label = [props.label];
        
        let tempProps = {
            error: error,
            isMobile: isMobile,
            errorText: error && error.join('')
        }
        return (
            // <div className={props.api_name} style={props.is_active?{}:{display:'none'}}>
            <div className={props.api_name}>
                <div className="input-label">{requireText}{label.join('、')}</div>
                {props.help_text ? <p className="input-help">{props.help_text}</p> : null}
                <Element {...props} {...tempProps}/>
                <WhiteSpace size='lg'/>
            </div>
        )
    }
    Component.displayName = `WrapComponent(${getDisplayName(Element)})`;
    return Component;
}
export default WrapComponent;


// WEBPACK FOOTER //
// ./src/component/WrapComponent.js